var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": _vm.transition.enter,
        "leave-active-class": _vm.transition.leave,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isActive,
              expression: "isActive",
            },
          ],
          staticClass: "toast",
          class: [_vm.type, _vm.position],
          attrs: { "aria-hidden": !_vm.isActive, role: "alert" },
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.message) } })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }